import { get, post, put } from '@/common/admin_ajax'


const getDetail = (id) => get(`metro_lines/${id}.json`)

const updateDetail = (id, data) => put(`metro_lines/${id}/trackways.json`, data)


export default {
    getDetail,
    updateDetail
}
